/* Hero a due foto (ottobre 2026): rotazione in dissolvenza, pausa, pallini, swipe, editor del tema. */
if (!customElements.get('hero-split')) {
  class HeroSplit extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.hero-split__slide'));
      this.dots = Array.from(this.querySelectorAll('.hero-split__dot'));
      this.pauseButton = this.querySelector('.hero-split__pause');
      if (this.slides.length < 2) return;

      this.index = 0;
      this.delay = parseInt(this.dataset.interval, 10) || 6000;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.userPaused = this.dataset.autoplay !== 'true' || reduceMotion;
      this.holds = new Set();

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.go(parseInt(dot.dataset.go, 10));
          this.restart();
        });
      });
      if (this.pauseButton) {
        this.pauseButton.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.render();
          this.restart();
        });
      }

      this.addEventListener('mouseenter', () => this.hold('hover', true));
      this.addEventListener('mouseleave', () => this.hold('hover', false));
      this.addEventListener('focusin', () => this.hold('focus', true));
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.hold('focus', false);
      });
      document.addEventListener('visibilitychange', () => this.hold('hidden', document.hidden));

      let startX = null;
      this.addEventListener('touchstart', (event) => {
        startX = event.touches[0].clientX;
      }, { passive: true });
      this.addEventListener('touchend', (event) => {
        if (startX === null) return;
        const dx = event.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        this.go(this.index + (dx < 0 ? 1 : -1));
        this.restart();
      });

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.indexOf(event.target);
          if (i > -1) {
            this.go(i);
            this.hold('editor', true);
          }
        });
        document.addEventListener('shopify:block:deselect', () => this.hold('editor', false));
      }

      this.render();
      this.restart();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    hold(reason, on) {
      if (on) this.holds.add(reason);
      else this.holds.delete(reason);
    }

    restart() {
      clearInterval(this.timer);
      if (this.userPaused) return;
      this.timer = setInterval(() => {
        if (this.holds.size === 0) this.go(this.index + 1);
      }, this.delay);
    }

    go(i) {
      const count = this.slides.length;
      this.index = ((i % count) + count) % count;
      this.slides.forEach((slide, k) => {
        const active = k === this.index;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('inert', '');
        }
      });
      this.dots.forEach((dot, k) => {
        const active = k === this.index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    render() {
      this.classList.toggle('is-paused', this.userPaused);
      if (this.pauseButton) {
        const label = this.userPaused ? this.pauseButton.dataset.labelPlay : this.pauseButton.dataset.labelPause;
        this.pauseButton.setAttribute('aria-label', label);
      }
    }
  }
  customElements.define('hero-split', HeroSplit);
}
